import { useCallback, useRef } from "react";
import FloatingChatRoot from "./root";
import { FloatingChatRef, FloatingChatShowParams } from "./types";

type RefObj = {
  current: FloatingChatRef | null;
};

let refs: RefObj[] = [];

function addNewRef(newRef: FloatingChatRef) {
  refs.push({ current: newRef });
}

function removeOldRef(oldRef: FloatingChatRef | null) {
  refs = refs.filter((r) => r.current !== oldRef);
}

type FloatingChatProviderProps = {
  brandId: string;
};

export default function FloatingChatProvider(props: FloatingChatProviderProps) {
  const floatingRef = useRef<FloatingChatRef | null>(null);

  const setRef = useCallback((ref: FloatingChatRef | null) => {
    if (ref) {
      floatingRef.current = ref;
      addNewRef(ref);
    } else {
      removeOldRef(floatingRef.current);
    }
  }, []);

  return <FloatingChatRoot ref={setRef} brandId={props.brandId} />;
}

function getRef() {
  const reversePriority = [...refs].reverse();
  const activeRef = reversePriority.find((ref) => ref?.current !== null);
  if (!activeRef) return null;
  return activeRef.current;
}

FloatingChatProvider.show = (params: FloatingChatShowParams) => {
  getRef()?.show(params);
};

FloatingChatProvider.hide = () => {
  getRef()?.hide();
};

FloatingChatProvider.toggle = () => {
  getRef()?.toggle();
};
